<app-button
  [iconClass]="'fas fa-plus'"
  [label]="labelKey() | translate"
  btnClass="btn btn-primary btn-sm action-btn"
  (clicked)="add.emit()"
/>
